import React, { useEffect } from "react"
import { graphql } from "gatsby"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"
import parse from "html-react-parser";
import Slider from "react-slick"
import marqueeEffect from "../../../hooks/marquee-effect"
import { gsap } from "gsap"

const QuoteContent = ({ gallery, title, richContent, secondRichContent, thirdTitle, thirdRichContent, fourthTitle, fourthRichContent}) => {

    useEffect(() => {
        marqueeEffect(gsap.utils.toArray(".campaign-content__slider--wrapper"), {paused: false, repeat: -1,});
    }, []);

  return (
    <section className='campaign-content'>
      <div className='campaign-content__inner'>
        <div className='campaign-content__top'>
          {gallery?.length > 0 && <Asset asset={gallery[0]} />}
          <div className='campaign-content__content'>
            {title && <h2>{parse(title)}</h2>}
            {richContent && <StructuredText data={richContent} />}
          </div>
          {gallery?.length > 0 && <Asset asset={gallery[1]} />}
        </div>

        <div className="campaign-content__middle">
          {gallery?.length > 0 && <Asset asset={gallery[2]} />}
          <div className="campaign-content__content">
            {secondRichContent && <StructuredText data={secondRichContent} />}
          </div>
          {gallery?.length > 0 && <Asset asset={gallery[3]} />}
          <div className="campaign-content__assets">
            {gallery?.length > 0 && <Asset asset={gallery[4]} />}
            {gallery?.length > 0 && <Asset asset={gallery[5]} />}
            {gallery?.length > 0 && <Asset asset={gallery[6]} />}
          </div>

          <div className="campaign-content__slider">
            <div className="campaign-content__slider--wrapper">
              {gallery?.length > 0 && <Asset asset={gallery[4]} />}
              {gallery?.length > 0 && <Asset asset={gallery[5]} />}
              {gallery?.length > 0 && <Asset asset={gallery[6]} />}
            </div>
            <div className="campaign-content__slider--wrapper">
              {gallery?.length > 0 && <Asset asset={gallery[4]} />}
              {gallery?.length > 0 && <Asset asset={gallery[5]} />}
              {gallery?.length > 0 && <Asset asset={gallery[6]} />}
            </div>
            <div className="campaign-content__slider--wrapper">
              {gallery?.length > 0 && <Asset asset={gallery[4]} />}
              {gallery?.length > 0 && <Asset asset={gallery[5]} />}
              {gallery?.length > 0 && <Asset asset={gallery[6]} />}
            </div>
          </div>
        </div>

        <div className="campaign-content__bottom">
          <div className="campaign-content__content">
            {thirdTitle && <h2>{parse(thirdTitle)}</h2>}
            {thirdRichContent && <StructuredText data={thirdRichContent} />}
          </div>
          {gallery?.length > 0 && <Asset className='first' asset={gallery[7]} />}
          {gallery?.length > 0 && <Asset className='second' asset={gallery[8]} />}
          <div className="campaign-content__content">
            {fourthTitle && <h2>{parse(fourthTitle)}</h2>}
            {fourthRichContent && <StructuredText data={fourthRichContent} />}
          </div>
        </div>
      </div>
    </section>
  )
}

export default QuoteContent

export const query = graphql`
  fragment CampaignContentProps on DatoCmsCampaignContent {
    ... on DatoCmsCampaignContent {
      id
      gallery {
        ...InternalAssetProps
      }
      title
      richContent {
        value
      }
      secondRichContent {
        value
      }
      thirdTitle
      thirdRichContent {
        value
      }
      fourthTitle
      fourthRichContent {
        value
      }
    }
  }
`